/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {ApiV0} from "../../api.v0";
import {RestApiService} from "../../../rest-api.service";
import {BookedProductDetailsRes} from "../../../../contracts/v0/cp";
import {LicenseAssignReq, LicenseOrderReq} from '../../../../contracts/v0/cp/license.contract';
import {Observable} from 'rxjs';

export class ApiV0License {
    segment = '/License';

    constructor(
        v0: ApiV0,
        private rest: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
    }


    assignLicense(licenseKey: string, userId: number): Observable<BookedProductDetailsRes> {
        const dto = new LicenseAssignReq();
        dto.licenseKey = licenseKey;
        dto.userId = userId;
        return this.rest.post<LicenseAssignReq, BookedProductDetailsRes>(
            `${this.segment}/`,
            BookedProductDetailsRes,
            dto
        );
    }

    revokeLicense(licenseId: number): Observable<BookedProductDetailsRes> {
        return this.rest.delete(`${this.segment}/${licenseId}`);
    }

    orderLicense(orderLicenseReq: LicenseOrderReq): Observable<BookedProductDetailsRes> {
        orderLicenseReq.selectedFeaturesIds = orderLicenseReq.selectedFeatures.map(x => x.id);
        orderLicenseReq.selectedFeatures = [];
        return this.rest.post<LicenseOrderReq, BookedProductDetailsRes>(
            `${this.segment}/Order`,
            BookedProductDetailsRes,
            orderLicenseReq
        );
    }
}